module.exports = __webpack_public_path__ + "img/customized.be8f4cc2.jpg";